import { api } from "../Configurations/axios";

const GetAllUsabilityLogsExcelAPI = async (initDate: Date | undefined, endDate: Date | undefined) => {
    try {
        const result = await api.get(`/Logs/GetAllUsabilityLogsExcel/?initDate=${initDate ? initDate?.toJSON() : ""}&endDate=${endDate ? endDate?.toJSON() : ""}`, {
            responseType: 'blob'
        });
        const response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const GetAllLoginLogsExcelAPI = async (initDate: Date | undefined, endDate: Date | undefined) => {
    try {
        const result = await api.get(`/Logs/GetAllLoginLogsExcel/?initDate=${initDate ? initDate?.toJSON() : ""}&endDate=${endDate ? endDate?.toJSON() : ""}`, {
            responseType: 'blob'
        });
        const response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const GetUsabilityByCompanyIdAPI = async (companyId: string, severityText: string = "", screenText: string = "", actionText: string = "", page: number = 1, take: number = 7, word: string = "") => {
    try {
        const result = await api.get(`/Logs/GetUsabilityByCompanyId/?CompanyId=${companyId}&severity=${encodeURIComponent(severityText)}&screen=${encodeURIComponent(screenText)}&action=${encodeURIComponent(actionText)}&Page=${page}&Take=${take}&Word=${encodeURIComponent(word)}`);
        const response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

export {
    GetAllUsabilityLogsExcelAPI,
    GetAllLoginLogsExcelAPI,
    GetUsabilityByCompanyIdAPI
}